function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M13.4971 4.48744C13.6273 4.33877 13.7869 4.21873 13.9657 4.13491C14.1446 4.05108 14.3389 4.00529 14.5363 4.00043C14.7337 3.99557 14.93 4.03174 15.1128 4.10666C15.2955 4.18158 15.4608 4.29362 15.5981 4.4357C15.7354 4.57779 15.8418 4.74684 15.9106 4.93217C15.9794 5.1175 16.009 5.3151 15.9976 5.51247C15.9863 5.70985 15.9341 5.90273 15.8446 6.07892C15.755 6.25512 15.6299 6.4108 15.4772 6.53615L14.5 7.51438L12.48 5.49142L13.49 4.48029L13.4971 4.48744ZM7.0175 15.0012V15.0027L4 16L4.99688 12.9789L5.99375 11.9815L7.9875 9.98663L11.975 5.99696L13.995 8.01992L10.0079 12.0092L8.01429 14.0039L7.0175 15.0012Z",
  fill: "currentColor"
});

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/edit.9bf0fdff.svg";
export { SvgComponent as ReactComponent };